export default __webpack_public_path__ + "static/media/dk.6c44836d.svg";